import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "700px",
    height: "280px",
    position: "relative",
    margin: theme.spacing(0, 0, 4, 0),
  },
  legends: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.32),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(2),
  },
  legendItems: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  legendDots: {
    display: "flex",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
  },
  legendLabel: {
    display: "flex",
    padding: theme.spacing(0, 0, 0, 0.5),
    fontSize: "14px",
    color: theme.custom.color.black,
  },
  tooltip: {
    backgroundColor: theme.custom.color.white,
    borderRadius: "100px 2px 2px 100px",
    boxShadow: theme.custom.boxShadow.tooltip,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  tooltipIcon: {
    display: "flex",
    fontSize: "24px",
  },
  tooltipLabel: {
    display: "flex",
    fontSize: "10px",
    letterSpacing: "0.19px",
    lineHeight: "11px",
    margin: theme.spacing(0, 0.8, 0, 0.5),
  },
  tooltipVal: {
    display: "flex",
    fontSize: "12px",
    color: theme.custom.color.black,
    fontWeight: "bold",
    lineHeight: "13px",
    marginRight: theme.spacing(0.6),
  },
}));
